import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach JWT (Bearer) from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ff_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve media: backend uploads (/api/..) get the backend host prefixed; site images stay as-is
export const resolveMedia = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

// Model photos extracted from the brand's reference imagery (models only).
const M = (n) => `/images/${n}.jpg`;

export const IMG = {
  heroHome: "/images/home-hero-bw.jpg",
  servicesPortrait: "/images/services-why.jpg",
  aboutHero: "/images/about-relationships.jpg",
  story: M("framed-kneel"),
  who: ["/images/who-a.jpg", "/images/who-b.jpg", "/images/who-c.jpg"],
  creators: [M("leather-hero"), M("seated-stool"), M("sitting-bra"), M("spotlight-leather"), M("bodysuit"), M("framed-stand")],
  products: [M("leather-hero"), M("seated-stool"), M("beach-model"), M("framed-stand"), M("bodysuit"), M("sitting-bra")],
  store: {
    hero: "/images/store-hero-green.jpg",
    wall: "/images/store-wall.jpg",
    desk: "/images/store-desk.jpg",
    income: "/images/store-income.jpg",
    limited: "/images/store-limited.jpg",
  },
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "For Creators", to: "/for-creators", role: "creator" },
  { label: "For Fans", to: "/for-fans", role: "fan" },
  { label: "Pricing", to: "/pricing", role: "creator" },
  { label: "About Us", to: "/about" },
];

// Effective role: logged-in account type wins; otherwise the RoleGate pick (ff_role). Hard-locked once set.
export const getEffectiveRole = (user) =>
  (user && user.type) || localStorage.getItem("ff_role") || null;

export const roleHome = (role) => (role === "fan" ? "/discover" : "/for-creators");

export const SOCIALS = [
  { name: "Instagram", href: "#" },
  { name: "TikTok", href: "#" },
  { name: "Twitter", href: "#" },
  { name: "YouTube", href: "#" },
];
